
import type { PropType } from 'vue';

import _debounce from 'lodash/debounce';

import axios from 'axios';

import {
  defineComponent,
  ref,
  watch,
  onMounted,
} from 'vue';

import PrimeVueDropdown from 'primevue/dropdown';

import PrimeVueInputText from 'primevue/inputtext';

import type { ErrorsMap } from '@/types';

import { AUTOCOMPLETE_ENTRIES_LIMIT } from '@/libs/consts';

export default defineComponent({
  components: {
    PrimeVueDropdown,
    PrimeVueInputText,
  },
  props: {
    modelValue: {
      type: Number,
    },
    name: {
      type: String,
    },
    errorsMap: {
      type: Object as PropType<ErrorsMap>,
      default: () => ({}),
    },
    label: {
      type: String,
      required: true,
    },
    help: {
      type: String,
    },
    showClear: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    apiParams: {
      type: Object,
      default: () => ({}),
    },
    optionLabel: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const options = ref<{ id: number }[]>([]);

    const keyword = ref();

    const loading = ref(false);

    const getOptions = async (): Promise<void> => {
      loading.value = true;

      try {
        const response = await axios.get(
          props.apiUrl,
          {
            params: {
              'filter[id]': props.modelValue && !options.value.length ? props.modelValue : undefined,
              'filter[keyword]': keyword.value,
              sort: '-id',
              per_page: AUTOCOMPLETE_ENTRIES_LIMIT,
              ...props.apiParams,
            },
          },
        );

        const mergedOptions = [
          ...options.value.filter((option) => props.modelValue === option.id),
          ...response.data.data,
        ];

        options.value = [...new Map(mergedOptions.map((option) => [option.id, option])).values()];
      } catch (err) {
        console.error(err);
      }

      loading.value = false;
    };

    watch(keyword, _debounce(() => getOptions(), 1000));

    watch(() => props.apiParams, () => getOptions());

    onMounted(() => getOptions());

    return {
      options,
      keyword,
      loading,
    };
  },
});
